import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    companyId: localStorage.getItem("companyId") || ""
  },
  getters: {
    getCompanyId(state) {
      return state.companyId
    }
  },
  mutations: {
    SET_COMPANY_ID(state, companyId) {
      state.companyId = companyId
    }
  },
  actions: {
  },
  modules: {
  }
})
